import { Injectable } from "@angular/core";

@Injectable()
export class UtilsService {
  constructor() {}

  // função para validar uma string, se contem apenas números ou
  // números e pontos (de acordo com o parâmetro informado)
  validaPattern(vlr, tipo) {
    var regex;
    switch (tipo) {
      case "apenasNumeros":
        regex = /^[0-9]+$/;
        break;
      case "apenasNumerosEpontos":
        regex = /^[0-9,.]+$/;
        break;
      default:
        regex = "";
        break;
    }

    if (regex.test(vlr)) {
      return true;
    } else {
      return false;
    }
  }

  // função para validar se o CPF é válido
  validaCPF(cpf) {
    var strCPF = cpf.replace(".", "").replace("-", "").replace(".", "");
    var Soma;
    var Resto;
    Soma = 0;
    if (
      strCPF == "00000000000" ||
      strCPF == "11111111111" ||
      strCPF == "22222222222" ||
      strCPF == "33333333333" ||
      strCPF == "44444444444" ||
      strCPF == "55555555555" ||
      strCPF == "66666666666" ||
      strCPF == "77777777777" ||
      strCPF == "88888888888" ||
      strCPF == "99999999999"
    )
      return false;

    for (var i = 1; i <= 9; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(9, 10))) return false;

    Soma = 0;
    for (var i = 1; i <= 10; i++)
      Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    Resto = (Soma * 10) % 11;

    if (Resto == 10 || Resto == 11) Resto = 0;
    if (Resto != parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }

  // função para retornar a data e hora atual no formato DD/MM/YYYY HH:MM:SS
  dataHoraAtual() {
    var data = new Date();
    var dia = String(data.getDate()).padStart(2, "0");
    var mes = String(data.getMonth() + 1).padStart(2, "0");
    var ano4 = data.getFullYear();
    var hora = String(data.getHours()).padStart(2, "0");
    var min = String(data.getMinutes()).padStart(2, "0");
    var seg = String(data.getSeconds()).padStart(2, "0");
    var str_data = dia + "/" + mes + "/" + ano4;
    var str_hora = hora + ":" + min + ":" + seg;
    return str_data + " " + str_hora;
  }

  // função para retornar apenas a data atual no formato DD/MM/YYYY
  dataAtual() {
    var data = new Date();
    var dia = String(data.getDate()).padStart(2, "0");
    var mes = String(data.getMonth() + 1).padStart(2, "0");
    var ano4 = data.getFullYear();
    var str_data = dia + "/" + mes + "/" + ano4;
    return str_data;
  }

  // função para tratar um número de acordo com casas decimais e separadores
  number_format(number, decimals, dec_point, thousands_sep) {
    number = number * 1; //makes sure `number` is numeric value
    var str = number.toFixed(decimals ? decimals : 0).split(".");
    var parts = [];
    for (var i = str[0].length; i > 0; i -= 3) {
      parts.unshift(str[0].substring(Math.max(0, i - 3), i));
    }
    str[0] = parts.join(thousands_sep ? thousands_sep : "");
    return str.join(dec_point ? dec_point : ".");
  }
}



// WEBPACK FOOTER //
// ./src/app/utils.service.ts